import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconHomeCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M11.6258 1.60003C11.8574 1.46666 12.1426 1.46666 12.3742 1.60003L20.6242 6.35003C20.8567 6.48389 21 6.73173 21 7V20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25V7C3 6.73173 3.14329 6.48389 3.37578 6.35003L11.6258 1.60003ZM8.75 12.25C8.75 10.4551 10.2051 9 12 9C13.7949 9 15.25 10.4551 15.25 12.25C15.25 14.0449 13.7949 15.5 12 15.5C10.2051 15.5 8.75 14.0449 8.75 12.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeCircle;
